import { h, Component } from 'preact';
import { accessNested, asList } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import pure from 'utils/pure';

function persons(obj) {
	if (!obj) return null;
	if (typeof obj === 'string' || obj.name) {
		obj = [obj];
	}
	return Object.values(obj).filter(e => e).map(person => {
		let obj = {
			'@type': 'Person'
		};
		if (typeof person === 'string') {
			obj.name = person;
		} else {
			Object.assign(obj, person);
		}
		return obj;
	});
}

// function strip_html_tags(str) {
// 	if ((str===null) || (str==='')) {
// 		return false;
// 	} else {
// 		str = str.toString();
// 	}
// 	return str.replace(/<[^>]*>/g, '');
// }

export default @pure class Seo extends Component {

	getExtraContent() { }

	render(props) {
		const {
			appData,
			shareImage
		} = props;

		// automatically generate some basic schema markup
		// http://schema.org/Movie

		if (!appData) return;
		let naiveReleaseDate = new Date(appData.meta.dates.release);
		let localeReleaseDate = new Date(naiveReleaseDate.getTime() + naiveReleaseDate.getTimezoneOffset() * 60 * 1000);
		const releaseDate = formatDateTime(localeReleaseDate, 'yyyy-MM-dd');

		let schema = {
			'@context':    'http://schema.org',
			'@type':       'Movie',
			name:          appData.meta.title.locale || appData.meta.title.en,
			description:   appData.copy.$SCHEMA_DESCRIPTION || appData.copy.$META_TITLE || '', // This should probable be something different/new, but is the closest we had to the example.
			image:         shareImage,
			url:           appData.meta.url,
			dateCreated:   releaseDate,
			releasedEvent: {
				'@type':     'PublicationEvent',
				startDate:   releaseDate,
				location: {
					'@type':   'Country',
					name:      appData.meta.region.slug.toUpperCase()
				}
			},
		};

		// Add in sameAs
		let sameAs;
		if (appData.meta.sameAs) {
			sameAs = Object.values(appData.meta.sameAs);
		} else {
			let social = appData.meta.social || {};
			sameAs = Object.keys(social).map(key => social[key].link);
		}
		schema.sameAs = sameAs;
		if (appData.meta.director) {
			schema.director = persons(appData.meta.director);
		}
		if (appData.meta.actor) {
			schema.actor = persons(appData.meta.actor);
		}
		// Add in trailers
		// Add in director + actors

		// set up the Schema for the trailer
		const list = asList(accessNested(appData, 'pages.videos.data.list') || []);
		const listHasVideo = list.find(item => item && item.ytid);
		const noShowtimesVideo = accessNested(appData, 'pages.videos.data.noShowtimesVideo');

		if (listHasVideo) {
			schema.trailer = {
				'@type':      'VideoObject',
				name:         listHasVideo.name,
				thumbnailUrl: listHasVideo.thumbSrc,
				url:          'https://www.youtube.com/watch?v=' + listHasVideo.ytid,
				description:  listHasVideo.name,
				uploadDate:   listHasVideo.publishedAt
			};
		} else if (noShowtimesVideo) {
			schema.trailer = {
				'@type':      'VideoObject',
				thumbnailUrl: 'https://i.ytimg.com/vi/' + noShowtimesVideo + '/maxresdefault.jpg',
				url:          'https://www.youtube.com/watch?v=' + noShowtimesVideo
			};
		}

		if (appData.doc.schema && typeof appData.doc.schema !== 'string') {
			// Basic Schema has been overriden by the appdata
			schema = appData.doc.schema;
		}

		return (
			<div>
				<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
				{this.getExtraContent()}
			</div>
		);
	}

}
